import { memo } from "react";
import GeneralCta from "../GeneralCta";
import useModalsStore from "src/store/modalsStore";
import useMobile from "src/hooks/useMobile";
import { useTranslation } from "react-i18next";
import { MdOutlineEmail, MdPersonSearch, MdSend } from "react-icons/md";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "src/components/Button/Button.types";

const NoSentInvitesCta: React.FC = () => {
  const { t } = useTranslation("ctas");
  const { isMobile } = useMobile();
  const { setShowContactSearchModal, setShowEmailInviteModal } =
    useModalsStore();

  return (
    <GeneralCta
      title="No has enviado invitaciones"
      description={t("pages:contacts.collapsibles.sent.empty")}
      icon={<MdSend size={isMobile ? ICON_SIZES.MD_LG : ICON_SIZES.LG} />}
      buttons={[
        {
          text: t("Buscar"),
          onClick: () => setShowContactSearchModal(true),
          icon: <MdPersonSearch size={ICON_SIZES.SM} />,
          kind: EButtonKind.SAVE,
        },
        {
          tooltip: t("Correo"),
          onClick: () => setShowEmailInviteModal(true),
          icon: <MdOutlineEmail size={ICON_SIZES.SM} />,
        },
      ]}
    />
  );
};

export default memo(NoSentInvitesCta);
